import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import Chart from "chart.js";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { timer } from "rxjs";
import { take } from "rxjs/operators";
import { applyRegion, environment } from "src/environments/environment";
import * as _ from "underscore";
import { find, isEmpty } from "underscore";
import { ResponseJobInfo } from "../commons/interfaces";
import { print_duration } from "../commons/utils";
import { ResponseJobResultV2 } from "./interfaces";
import {
    // tslint:disable-next-line:max-line-length
    addEdge, buildDataSource, cleanEdgesBasedOnAmount, cleanSuspectNodes, EdgeItem, getEntityValues, getPartners, mergeSimilarEdges, mergeSimilarNodes,
    NodeItem, removeNonConnectedNodes
} from './news-analyzer.utils';
import { filterValues, getColor, rgba2rgb } from './utils';


@Component({
    selector: "app-news-analyzer",
    templateUrl: "./news-analyzer.component.html",
    styleUrls: ["./news-analyzer.component.css"]
})
export class NewsAnalyzerComponent implements OnInit {
    BATCH_SIZE = 100;

    providerInfoForm: FormGroup;
    nerTypes = []
    summary: string;
    topic: string;
    topicScore: number;
    selectedNERType: string;
    commentsNer: {};
    commentsNerLabels: string[];
    chartOptions: {};
    barChartNer: Chart;
    barChartTopics: Chart;
    barChartSentiment: Chart;
    showResults: boolean;
    progressInfo: {
        total: number,
        current: number,
        position: number | null,
        description: string
    };
    article = {
        text: '',
        comments: [],
        paragraphs: []
    };
    isProcessingArticle: boolean;
    itemsTitle = '';
    items = [];
    tokenHasError: any[];
    hasErrorProcessing: any[];
    pairsKeyLongKey = [
        ['ADR', 'Dirección'],
        ['ANM', 'Animal'],
        ['BLD', 'Construcción'],
        ['COM', 'Compañía'],
        ['DAT', 'Fecha'],
        ['DEV', 'Dispositivo'],
        ['DOC', 'Documento'],
        ['EVN', 'Evento'],
        ['FDD', 'Comida'],
        ['GEA', 'Geografía física'],
        ['GEO', 'Geografía administrativa'],
        ['GEX', 'Geografía extendida'],
        ['HOU', 'Horas'],
        ['LEN', 'Entidad legal'],
        ['LOC', 'Ubicación'],
        ['MAI', 'Correo'],
        ['MEA', 'Medida'],
        ['MISC', 'Otros'],
        ['MMD', 'Órgano de prensa'],
        ['MON', 'Dinero'],
        ['NPH', 'Person'],
        ['PCT', 'Porciento'],
        ['PER', 'Persona'],
        ['PHO', 'Teléfono'],
        ['PPH', 'Fenómeno físico'],
        ['PRD', 'Producto'],
        ['ORG', 'Organización'],
        ['VCL', 'Vehículo'],
        ['WEB', 'Web'],
    ];
    nodes: NodeItem[];
    edges: EdgeItem[];
    nodesTopics: { id: number; value: number; label: string; color: string }[];
    edgesTopics: { from: number; to: number; value: number; color: string }[];
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        })
    };

    dataSource: { position, text, sentiment, topic }[] = []

    selectedType: any;
    token: string;

    constructor(private http: HttpClient, protected $gaService: GoogleAnalyticsService) { }

    async ngOnInit(): Promise<void> {
        this.isProcessingArticle = false;
        this.showResults = false;
        this.tokenHasError = [false, ''];
        this.hasErrorProcessing = [false, '']
        this.progressInfo = {
            total: 0,
            current: 0,
            position: null,
            description: ''
        };
        this.providerInfoForm = new FormGroup({
            purl: new FormControl("", [Validators.required]),
            ptoken_compai: new FormControl("", [Validators.required]),
        });

        this.chartOptions = {
            maintainAspectRatio: false,
            responsive: true,
            tooltips: { mode: "index", intersect: false },
            hover: { mode: "nearest", intersect: true },
            legend: { display: false },
            scales: {
                xAxes: [
                    {
                        display: true,
                        ticks: { suggestedMin: 0, stepSize: 1 },
                        gridLines: {
                            borderDash: [2],
                            borderDashOffset: [2],
                            color: "rgba(33, 37, 41, 0.3)",
                            zeroLineColor: "rgba(33, 37, 41, 0.3)",
                            zeroLineBorderDash: [2],
                            zeroLineBorderDashOffset: [2],
                        },
                    },
                ],
                yAxes: [
                    {
                        display: true,
                        gridLines: {
                            borderDash: [2],
                            drawBorder: false,
                            borderDashOffset: [2],
                            color: "rgba(33, 37, 41, 0.2)",
                            zeroLineColor: "rgba(33, 37, 41, 0.15)",
                            zeroLineBorderDash: [2],
                            zeroLineBorderDashOffset: [2],
                        },
                    },
                ],
            },
        };

        this.$gaService.pageView("/", "News Analyzer");
    }

    async processArticleAsync() {
        this.$gaService.event("analyze_news");

        this.isProcessingArticle = true;
        this.tokenHasError = [false, ''];
        this.hasErrorProcessing = [false, ''];
        const startTime = Date.now()
        this.showResults = false;
        this.items = [];

        const url = this.providerInfoForm.value.purl;
        this.token = this.providerInfoForm.value.ptoken_compai;
        let errorMsg = 'Ha ocurrido un error procesando la información de la URL. Por favor inténtelo de nuevo.'

        if (this.isProcessing() || url === '' || this.token === '')
            return;

        const jobInfo = await this.callNewsAnalyzerEndpointV2(url, this.token);
        if (jobInfo === undefined) {
            showErrorMessage();
            return
        }
        console.log(jobInfo);

        let response = await this.callJobResultsEndpointV2(jobInfo.job);
        if (response === undefined) {
            showErrorMessage();
            return
        }
        while (response.status !== 'FINISHED' && response.status !== 'ERROR') {
            response = await this.callJobResultsEndpointV2(jobInfo.job);
            if (response === undefined) {
                showErrorMessage();
                return
            }
            if (response.result !== undefined && _.keys(response.result).length > 0) {
                this.progressInfo.current = response.result.progress.current;
                this.progressInfo.total = response.result.progress.total;
                this.progressInfo.description = response.result.progress.description;
            }
            this.progressInfo.position = response.position;
            await timer(3000).pipe(take(1)).toPromise();
        }
        console.log(response);
        switch (response.status) {
            case 'FINISHED':
                this.showResults = false;
                if (response.result === undefined ||
                    response.result === null) {
                    this.hasErrorProcessing = [true, errorMsg]
                }
                else if (response.result[0] !== undefined && response.result[0] === 'error-token') {
                    const tokenErrorMap = {
                        'token-not-provided': 'El token no fue provisto.',
                        'token-inactive': 'El token existe pero no está activo.',
                        'token-without-points': 'El token existe pero no tiene puntos disponibles.',
                        'token-not-exist': 'El token no existe en la base de datos.'
                    };
                    errorMsg = tokenErrorMap[response.result[1][0]];
                    this.tokenHasError = [true, errorMsg];
                }
                else if (isEmpty(response.result.article.paragraphs) && isEmpty(response.result.article.comments)) {
                    this.hasErrorProcessing = [true, 'No se pudo obtener ninguna información textual de la URL provista. Si considera que pudo haber sido un problema de la aplicación, contáctenos para chequear los resultados.']
                }
                else {
                    this.showResults = true;
                    await this.updateCharts(response);
                }
                break;
            case 'ERROR':
                this.showResults = false;
                break;
        }
        console.log('Process ' + response.status.toLowerCase());
        this.progressInfo = {
            total: 0,
            current: 0,
            position: null,
            description: ''
        };
        this.isProcessingArticle = false;
        print_duration(startTime)

        if (!this.showResults)
            return

        const allTexts = [response.result.article.comments, response.result.article.paragraphs]
        const entLabels = getEntityValues(response.result.article, ['MISC'])
        this.nodes = [];
        let id = 1;
        const textIdxEnts = []
        // tslint:disable-next-line:forin
        for (const label of entLabels) {
            let count = 0;
            let textIdx = 0;
            for (const coll of allTexts)
                for (const item of coll) {
                    if (item.toLowerCase().indexOf(label.toLowerCase()) >= 0) {
                        count++;
                        textIdxEnts.push([textIdx, id])
                    }
                    textIdx++;
                }

            const node = { id, value: count, label };
            this.nodes.push(node);
            id++;
        }
        this.nodes = cleanSuspectNodes(this.nodes);

        this.edges = [];

        // tslint:disable-next-line:forin
        for (let k = 1; k <= this.nodes.length; k++) {
            const partners = getPartners(k, textIdxEnts)
            for (const p of partners)
                addEdge(k, p, this.edges)
        }

        this.nodes = removeNonConnectedNodes(this.nodes, this.edges)
        const tmp = mergeSimilarNodes(this.nodes, this.edges)
        this.nodes = tmp[0]
        console.log(['Nodes', this.nodes.length])
        this.edges = tmp[1]
        this.edges = mergeSimilarEdges(this.edges)
        this.edges = cleanEdgesBasedOnAmount(this.edges)
        this.nodes = removeNonConnectedNodes(this.nodes, this.edges)

        console.log(['Edges', this.edges.length])

        const tmpTopics = this.buildGraphTopics(
            response.result.article.topics_paragraphs,
            response.result.article.sentiments_paragraphs)
        this.nodesTopics = tmpTopics[0]
        this.edgesTopics = tmpTopics[1]

        this.dataSource = buildDataSource(response.result.article)

        function showErrorMessage() {
            this.hasErrorProcessing = [true, errorMsg];
            this.showResults = false;
        }
    }

    buildGraphTopics(listTopics: [], listSentiments: { label: string, score: number }[]): any {
        const nodes: {
            id: number; value: number; label: string; color: string, posCount: number, negCount: number
        }[] = []
        const edges: {
            from: number; to: number; value: number; color: string, posCount: number, negCount: number
        }[] = []

        let prevNode: { id: number; value: number; label: string; }
        for (let i = 0; i < listTopics.length; i++) {
            const topicValue = listTopics[i][0]
            let posCount = 0
            let negCount = 0
            listSentiments[i].label === 'positive' ? posCount++ : negCount++

            let nodeFound = find(nodes, (n) => n.label === topicValue)
            if (nodeFound === undefined) {
                const tmpNode = {
                    id: i + 1, value: 1, label: topicValue, color: undefined,
                    posCount,
                    negCount
                }
                nodes.push(tmpNode)
                nodeFound = tmpNode
            }
            else {
                nodeFound.value++
                nodeFound.posCount += posCount
                nodeFound.negCount += negCount
            }
            if (prevNode !== undefined && prevNode.id !== nodeFound.id) {
                let ePos = 0
                let eNeg = 0
                listSentiments[i - 1].label === 'positive' ? ePos++ : eNeg++
                listSentiments[i].label === 'positive' ? ePos++ : eNeg++
                addEdge(prevNode.id, nodeFound.id, edges, ePos, eNeg)
            }
            prevNode = nodeFound
        }
        this.setColors(nodes);
        this.setColors(edges);

        return [nodes, edges]
    }


    private setColors(itemList: { color: string; posCount: number; negCount: number; }[]) {
        let color;
        let alpha;
        for (const item of itemList) {
            [color, alpha] = getColor(item.negCount, 0, item.posCount);
            const rgbStr = _.chain(rgba2rgb(color, alpha))
                .map(x => x.toString())
                .value();
            item.color = `rgb(${rgbStr})`;
        }
    }

    myIsNaN(n: number): boolean {
        return isNaN(n)
    }

    // private async callJobResultsEndpoint(jobId: string) {
    //     const endpointUrl = environment.apiUrl + 'get_job_result/' + jobId;
    //     const httpOptions = {
    //         headers: new HttpHeaders({
    //             "Content-Type": "application/json",
    //         })
    //     };
    //     return this.http.get<ResponseJobResult>(endpointUrl, httpOptions).pipe().toPromise();
    // }

    private async callJobResultsEndpointV2(jobId: string) {
        const endpointUrl = environment.appsUrl + 'v2/news_analyzer/job_result/' + jobId;

        const urls = []
        urls.push(environment.heroku + 'apps/v2/news_analyzer/job_result/' + jobId)
        urls.push(applyRegion(endpointUrl, environment.renderRegions.oregon))
        urls.push(applyRegion(endpointUrl, environment.renderRegions.frankfurt))

        for (const link of urls) {
            try {
                return await this.http.get<ResponseJobResultV2>(link, this.httpOptions).pipe().toPromise();
            } catch (error) {
                continue
            }
        }
    }

    // private async callNewsAnalyzerEndpoint(url: string, token: string) {
    //     const body = { token, url };
    //     const endpointUrl = environment.appsUrl + 'news_analyzer'
    //     const httpOptions = {
    //         headers: new HttpHeaders({
    //             "Content-Type": "application/json",
    //         })
    //     };
    //     return this.http.post<ResponseJobInfo>(endpointUrl, body, httpOptions).pipe().toPromise();
    // }

    private async callNewsAnalyzerEndpointV2(url: string, token: string) {
        const body = { token, url };
        const endpointUrl = environment.appsUrl + 'v2/news_analyzer'

        const urls = []
        urls.push(environment.heroku + 'apps/v2/news_analyzer')
        urls.push(applyRegion(endpointUrl, environment.renderRegions.oregon))
        urls.push(applyRegion(endpointUrl, environment.renderRegions.frankfurt))

        for (const link of urls) {
            try {
                return await this.http.post<ResponseJobInfo>(link, body, this.httpOptions).pipe().toPromise();
            } catch (error) {
                continue
            }
        }
    }

    private async updateCharts(jobResult: ResponseJobResultV2) {
        const results = jobResult.result.article;
        this.topic = results.topics[0];
        this.topicScore = results.topics[1];

        if (_.isEmpty(results.items_topics)) return;

        this.article.comments = results.comments
        this.article.paragraphs = results.paragraphs
        if (this.article.comments.length > 0) {
            this.itemsTitle = 'Comentarios';
            this.items = this.article.comments;
        }
        else {
            this.itemsTitle = 'Párrafos';
            this.items = this.article.paragraphs;
        }

        this.nerTypes = []
        const articleEntities = results.entities;
        for (const key in articleEntities) {
            if (Object.prototype.hasOwnProperty.call(articleEntities, key)) {
                const values = filterValues(articleEntities[key], results.entities_pos);
                if (values.length > 0)
                    this.nerTypes.push([key, values, this.getLongKey(key)]);
            }
        }

        this.commentsNer = results.items_entities;
        this.commentsNerLabels = _.chain(this.commentsNer)
            .allKeys()
            .sortBy((x) => x)
            .value();

        this.onNERSelectedChanged(this.commentsNerLabels[0]);

        const configTopics = {
            type: "horizontalBar",
            data: {
                labels: _.allKeys(results.items_topics),
                datasets: [
                    {
                        backgroundColor: "#4c51bf",
                        borderColor: "#4c51bf",
                        data: _.values(results.items_topics),
                        fill: false,
                        barThickness: 8,
                    },
                ]
            },
            options: this.chartOptions,
        };

        const configSentiment = {
            type: "horizontalBar",
            data: {
                labels: ["1", "2", "3", "4", "5",],
                datasets: [
                    {
                        backgroundColor: "#4c51bf",
                        borderColor: "#4c51bf",
                        data: results.items_sentiments,
                        fill: false,
                        barThickness: 8,
                    },
                ],
            },
            options: this.chartOptions,
        };

        if (this.barChartTopics !== undefined)
            this.barChartTopics.destroy();
        let ctx: any = document.getElementById("bar-chart-topics");
        ctx = ctx.getContext("2d");
        this.barChartTopics = new Chart(ctx, configTopics);

        if (this.barChartSentiment !== undefined)
            this.barChartSentiment.destroy();
        ctx = document.getElementById("bar-chart-sentiment");
        ctx = ctx.getContext("2d");
        this.barChartSentiment = new Chart(ctx, configSentiment);
    }

    join(separator: string, list: string[]) {
        return list.join(separator)
    }

    isProcessing() {
        if (this.showResults === true)
            return false;
        return this.progressInfo.total > 0 && this.progressInfo.total !== this.progressInfo.current;
    }

    onNERSelectedChanged(newLongKey: string) {
        this.selectedNERType = this.getKey(newLongKey);
        const lbls = _.chain(this.commentsNer[this.selectedNERType])
            .allKeys()
            .sortBy((x) => x)
            .value()
        const values = [];
        for (const lbl of lbls) {
            values.push(this.commentsNer[this.selectedNERType][lbl]);
        }
        const dataSourceNer = {
            labels: lbls,
            datasets: [
                {
                    backgroundColor: "#ed64a6",
                    borderColor: "#ed64a6",
                    data: values,
                    fill: false,
                    barThickness: 8,
                },
            ],
        }
        const configNer = {
            type: "horizontalBar",
            data: dataSourceNer,
            options: this.chartOptions,
        };

        if (this.barChartNer !== undefined)
            this.barChartNer.destroy();
        let ctx: any = document.getElementById("bar-chart-ner");
        ctx = ctx.getContext("2d");
        this.barChartNer = new Chart(ctx, configNer);
    }

    getLongKey(key: string): string {
        for (const item of this.pairsKeyLongKey)
            if (item[0] === key)
                return item[1]
        return key
    }

    getKey(longKey: string): string {
        for (const item of this.pairsKeyLongKey)
            if (item[1] === longKey)
                return item[0]
        return longKey
    }
}
